import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import {
  DEV_MODE_QUERY_PARAM,
  DEV_MODE_QUERY_VALUE,
  isLocalDevHostname
} from '@app/core/init/utils';

import { AuthSessionService } from '@core/services/auth-session.service';

/**
 * Remove `?mode=dev` da URL devolvendo um {@link UrlTree} sem o parâmetro (substitui a navegação
 * atual, mesmo efeito prático do {@link stripTokenGuard} com token).
 *
 * **Ordem:** imediatamente **depois** de {@link authGuard} e **antes** de {@link authInitGuard}.
 * Se rodasse depois do init, o redirect cancelaria a navegação já após `initialize()` e os guards
 * rodariam de novo — duplicando `usuario` / `options` / `termsByUser`.
 *
 * Sem sessão não altera a URL (bypass dev continua a ver `?mode=dev`). Com sessão e `mode=dev`,
 * normaliza a URL antes da hidratação.
 */
export const stripLocalDevQueryGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const auth = inject(AuthSessionService);

  if (!isLocalDevHostname()) {
    return true;
  }

  if (!auth.snapshot.isAuthenticated) {
    return true;
  }

  const tree = router.parseUrl(state.url);
  if (tree.queryParams[DEV_MODE_QUERY_PARAM] !== DEV_MODE_QUERY_VALUE) {
    return true;
  }

  delete tree.queryParams[DEV_MODE_QUERY_PARAM];
  return tree;
};
